import { IComponentOptions, IFormController, IPromise } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { IIndicator } from "@gtmhub/error-handling";
import { WarningModalService } from "@gtmhub/shared/components";
import { TagService } from "@gtmhub/tags/tagService";
import { StateService } from "@uirouter/core";
import { ITag } from "@gtmhub/tags/models";

export class MergeTagsCtrl extends GtmhubController {
  public form: IFormController;

  public mergeTarget: {
    tags?: ITag[];
    name?: string;
  } = {};

  public indicators: {
    loading?: IIndicator;
    saving?: IIndicator;
  } = {};

  public existingTagNames: string[] = [];

  public get tagAlreadyExists(): boolean {
    return this.existingTagNames?.includes(this.mergeTarget.name?.toLowerCase());
  }

  public get isFormValid(): boolean {
    return this.form?.$valid && this.mergeTarget.tags?.length > 0;
  }

  public static $inject = ["WarningModalService", "TagService", "$state"];

  constructor(private modalService: WarningModalService, private tagService: TagService, private $state: StateService) {
    super();
  }

  public $onInit(): void {
    this.indicators.loading = { progress: true };

    this.tagService
      .getTagsV2({ fields: "name", limit: -1 })
      .then((response) => (this.existingTagNames = response.items.map((item) => item.name)))
      .then(() => this.resetIndicators())
      .catch((error) => (this.indicators.loading = { error }));
  }

  public resetIndicators(): void {
    this.indicators = {};
  }

  public submit(): void {
    if (!this.isFormValid) {
      return;
    }

    if (this.tagAlreadyExists) {
      this.modalService
        .warningModal({
          modalTitle: "merge_tags",
          modalText: "tag_exists_merge_warning",
          modalImage: "/dist/img/cannot-continue.svg",
          modalClass: "merge-tags-confirm-modal",
          confirmBtnType: "destructive",
          confirmText: "merge",
          dismissText: "cancel",
        })
        .then(() => this.mergeTags())
        .catch(() => null);
    } else {
      this.mergeTags();
    }
  }

  public mergeTags(): IPromise<void> {
    this.indicators.saving = { progress: true };
    const tagIds = (this.mergeTarget.tags || []).map((tag) => tag.id);

    return this.tagService
      .mergeTags(tagIds, this.mergeTarget.name)
      .then(() => this.cancel())
      .catch((error) => {
        this.indicators.saving = { error };
      });
  }

  public cancel(): void {
    this.$state.go("gtmhub.configuration.tags");
  }
}

export const MergeTagsCompoent: IComponentOptions = {
  controller: MergeTagsCtrl,
  templateUrl: require("./merge-tags.component.html"),
};
